import { t } from "i18next";
import { setLocale } from "yup";

// Ensure this file gets imported before other files;
// otherwise, there will be issues with translations for some input fields
setLocale({
  mixed: {
    required: (field) => `${field.label} ${t("is a required field")}`,
  },
});
